import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { translateText } from '../../utils';
import { HelpLabel, InlineField } from '../controls';
import css from './AdvancedSettings.css';
import { DEEP_LINK_TEXT_MAX_LENGTH, deepLinkRequirementsUrl } from './constants';
import { sitePropType } from './propTypes';

const AndroidLinksSection = ({ site, translate, readOnly, onSitePatch }) => (
    <section className={css.formSection}>
        <h4>
            <Translate id="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_SPECIFIC" />
        </h4>
        <div className={css.richText}>
            {translate(
                'STATIC.PAGES.APPS_CONFIGURATION.ANDROID_DEEP_LINKING_DESCRIPTION',
                { requirementsUrl: deepLinkRequirementsUrl },
                { renderInnerHtml: true }
            )}
        </div>
        <div className={css.formGridStacked}>
            <InlineField
                label={
                    <HelpLabel
                        id="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_APP_LINKS"
                        tooltip="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_APP_LINKS_TOOLTIP"
                    />
                }
                value={site.app_signing_certificate}
                disabled={readOnly}
                maxLength={DEEP_LINK_TEXT_MAX_LENGTH}
                placeholder={translateText(
                    translate,
                    'STATIC.PAGES.APPS_CONFIGURATION.PLACEHOLDERS.APP_LINK_SIGNING_CERTIFICATE'
                )}
                onChange={value => onSitePatch({ app_signing_certificate: value })}
            />
            <InlineField
                label={
                    <HelpLabel
                        id="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_APP_SCHEME"
                        tooltip="STATIC.PAGES.APPS_CONFIGURATION.ANDROID_APP_SCHEME_TOOLTIP"
                    />
                }
                value={site.app_scheme}
                disabled={readOnly}
                maxLength={DEEP_LINK_TEXT_MAX_LENGTH}
                placeholder={translateText(translate, 'STATIC.PAGES.APPS_CONFIGURATION.PLACEHOLDERS.APP_SCHEME')}
                onChange={value => onSitePatch({ app_scheme: value })}
            />
        </div>
    </section>
);

AndroidLinksSection.propTypes = {
    onSitePatch: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
    site: sitePropType.isRequired,
    translate: PropTypes.func.isRequired,
};

export default AndroidLinksSection;
